export interface ProTipArticle {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  heroImage: string;
  metaTitle: string;
  metaDescription: string;
}

export const proTipsArticles: ProTipArticle[] = [
  {
    slug: "choosing-a-professional-masonry-company",
    title: "The Benefits of Choosing a Professional Masonry Company",
    excerpt:
      "From expertise and skilled teams to outstanding customer service and solid warranties, discover why hiring a professional masonry company protects your investment and delivers lasting results.",
    date: "2026-03-01",
    heroImage: "brick-work-masonry-stairs-wayne-nj-hero.webp",
    metaTitle:
      "Benefits of Hiring a Professional Masonry Company | Masonry Pro",
    metaDescription:
      "Why hire a professional masonry company? Expert craftsmanship, skilled teams, warranties, and service that protect your NJ investment.",
  },
  {
    slug: "benefits-of-adding-a-paver-patio",
    title:
      "Why a Paver Patio Makes Sense for North Jersey Homeowners",
    excerpt:
      "Thinking about a paver patio in North Jersey? Here is what our 30+ years of experience across Bergen, Passaic, Essex, and Morris Counties has taught us about what works and what doesn't.",
    date: "2026-03-17",
    heroImage: "paver-patio-north-new-jersey.webp",
    metaTitle:
      "Paver Patios in North Jersey: Pro Tips | Masonry Pro",
    metaDescription:
      "Thinking about a paver patio in North Jersey? Here is what our 30+ years of experience across Bergen, Passaic, Essex, and Morris Counties has taught us about what works and what doesn't.",
  },
  {
    slug: "what-is-a-stoop",
    title:
      "What Is a Stoop? The History Behind North Jersey's Favorite Front Entry",
    excerpt:
      "The word \"stoop\" comes from the Dutch \"stoep\" and has deep roots in North Jersey architecture. Learn what makes a stoop different from regular steps, why they matter, and when they need repair.",
    date: "2026-03-27",
    heroImage: "steps-stoops-masonry-wayne-nj.webp",
    metaTitle:
      "What Is a Stoop? History of Steps & Stoops in NJ | Masonry Pro",
    metaDescription:
      "The word \"stoop\" comes from the Dutch \"stoep\" and has deep roots in North Jersey architecture. Learn what makes a stoop different from steps and when they need repair.",
  },
  {
    slug: "paver-patio-cost-north-jersey",
    title: "Paver Patio Cost in North Jersey: What Really Drives the Price",
    excerpt:
      "Three contractors, three different prices. Here is what really drives paver patio cost in North Jersey: materials, prep, and the part of the job you never see.",
    date: "2026-06-11",
    heroImage: "mp-hero-paver-patio-installation-paramus-nj-061126.webp",
    metaTitle: "Paver Patio Cost North Jersey - What Drives It | Masonry Pro",
    metaDescription:
      "What does a paver patio really cost in North Jersey? See real price ranges by size and material, and what drives the number up or down. Free estimates.",
  },
];
